import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { S3IssuersEdit } from "./edit";
import { S3IssuersNew } from "./new";
import { S3IssuersTable } from "./table";

export default function S3Issuers() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Émetteurs");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<S3IssuersEdit />} />
      <Route index element={<S3IssuersTable />} />
      <Route path="/new" element={<S3IssuersNew />} />
    </Routes>
  );
}
